/**
 * This file holds the actions/mutations types
 * For more information about why this is needed
 * check here https://vuex.vuejs.org/guide/mutations.html#using-constants-for-mutation-types
 */

export const SET_VIEWS = "SET_VIEWS";
export const RESET_VIEWS = "RESET_VIEWS";
export const DEFAULT_VIEW = "DEFAULT_VIEW";
export const NEXT_VIEW = "NEXT_VIEW";
export const PREV_VIEW = "PREV_VIEW";
export const SET_MODELS_STYLE = "SET_MODELS_STYLE";
export const SET_MODELS_DATA = "SET_MODELS_DATA";
export const SET_SELECTED_STYLE = "SET_SELECTED_STYLE";
export const SET_SELECTED_COMBINATION = "SET_SELECTED_COMBINATION";
export const SET_SELECTED_SVG_SRC = "SET_SELECTED_SVG_SRC";
export const SET_SELECTED_PRODUCT_NAME = "SET_SELECTED_PRODUCT_NAME";
export const SET_SELECTED_COLOR = "SET_SELECTED_COLOR";
export const RESET_SELECTED_COLOR = "RESET_SELECTED_COLOR";
export const RESET_SELECTED_STYLE = "RESET_SELECTED_STYLE";
export const RESET_ACTIVE_VIEW = "RESET_ACTIVE_VIEW";
export const SET_STEP_NUMBER = "SET_STEP_NUMBER";
export const SET_TOTAL_COMBINATIONS = "SET_TOTAL_COMBINATIONS";

export const LOAD_SVG = "LOAD_SVG";
export const LOAD_COMBINATIONS = "LOAD_COMBINATIONS";

export const GET_RANDOMIZER_TILES = "GET_RANDOMIZER_TILES";
export const FETCH_PRODUCT_DATA = "FETCH_PRODUCT_DATA";
export const GET_PRODUCT_DATA = "GET_PRODUCT_DATA";
export const SET_COLOR_TILES = "SET_COLOR_TILES";
export const SET_ACTIVATE_COLOR_TILES = "SET_ACTIVATE_COLOR_TILES";
export const RESET_ACTIVATE_COLOR_TILES = "RESET_ACTIVATE_COLOR_TILES";
export const SET_AVAILABLE_SWATCHES = "SET_AVAILABLE_SWATCHES";

export const RESTART_CLICK_COUNT_COLOR_PALETTE = "RESTART_CLICK_COUNT_COLOR_PALETTE";

export const SET_CTA_TILES = "SET_CTA_TILES";
export const UPDATE_AVAILABLE_SWATCHES =  "UPDATE_AVAILABLE_SWATCHES";

export const SET_DEFAULT_RECIPE = "SET_DEFAULT_RECIPE";

export const SET_PRODUCT_TYPE = "SET_PRODUCT_TYPE";
export const SET_SOURCE = "SET_SOURCE";
